import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: -70px;
  height: 100%;
`;

export const Text = styled.div`
  font-size: 20px;
  text-align: center;
`;
